<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-动态-添加
    -->
    <el-dialog
    title="添加动态"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">


         <el-form-item label="所属分类：" prop="form.category_id">
      <el-select v-model="form.category_id">
        <template v-for="cat in catgory">
          <el-option :value="cat.category_id" :key="cat.category_id" :label="cat.name"></el-option>
          <template v-if="cat.child !== undefined" v-for="two in cat.child">
            <el-option :value="two.category_id" :key="two.category_id" :label="two.name" style="padding-left: 30px"></el-option>
            <template v-if="two.child !== undefined" v-for="three in two.child">
              <el-option :value="three.category_id" :key="three.category_id" :label="three.name" style="padding-left: 60px"></el-option>
            </template>
          </template>
        </template>
      </el-select>
    </el-form-item> 
      
    <el-form-item label="标题" prop="name">
      <el-input v-model="form.name" placeholder="请输入标题" class="max-w460"></el-input>
    </el-form-item>



      <el-form-item label="动态介绍">
        <div class="edit_container">
          <Uediter v-model="form.context" :text="ueditor.text" :config="ueditor.config" ref="ue"></Uediter>
        </div>
      </el-form-item>  


     <el-form-item label="视频图片：" prop="model.media">
  <div class="draggable-list">
    <draggable class="wrapper" v-model="form.media">
      <transition-group>
        <div v-for="(item, index) in form.media" :key="item.file_path">
          <div class="item">
            <!-- 根据文件类型显示图片或视频 -->
            <template v-if="isVideoFile(item.file_path)">
              <video 
                :src="item.file_path" 
                controls 
                preload="metadata"
                style="width: 100%; height: 100%; object-fit: cover;"
              ></video>
            </template>
            <template v-else>
              <img v-img-url="item.file_path" alt="file_path" style="width: 100%; height: 100%; object-fit: cover;" />
            </template>
            <a
              href="javascript:void(0);"
              class="delete-btn"
              @click.stop="deleteImg(index, 'album')"
              ><i class="el-icon-close"></i
            ></a>
          </div>
        </div>
      </transition-group>
    </draggable>
    <div class="item img-select" @click="openProductUpload('album')">
      <i class="el-icon-plus"></i>
    </div>
  </div>
</el-form-item>


<el-form-item label="动态审核状态" prop="review_status">
  <el-select v-model="form.review_status" placeholder="选择审核状态" class="max-w460">
    <el-option label="待审核" :value="0"></el-option>
    <el-option label="已审核" :value="1"></el-option>
    <el-option label="未通过" :value="2"></el-option>
  </el-select>
</el-form-item>

<el-form-item label="上架/恢复状态" prop="status">
  <el-select v-model="form.status" placeholder="选择状态" class="max-w460">
    <el-option label="上架" :value="1"></el-option>
    <el-option label="恢复" :value="0"></el-option>
  </el-select>
</el-form-item>

<el-form-item label="动态类型" prop="note_type">
  <el-select v-model="form.note_type" placeholder="选择动态类型" class="max-w460">
    <el-option label="正式" :value="1"></el-option>
    <!-- <el-option label="草稿" value="draft"></el-option> -->
  </el-select>
</el-form-item>

     

      <el-form-item label="排序" prop="name"><el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input></el-form-item>
       
    

    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
     <!--商品图片组件-->
     <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
    <!-- <Categoryas :isproduct="iscategorya" :excludeIds="excludeIds" :islist="false" @closeDialog="closeDialogFunc"></Categoryas> -->
  </div>
</el-dialog>
  
</template>

<script>
import NotesApi from '@/api/notes.js';

import Upload from '@/components/file/Upload';
// import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
export default {
  components: {

     /*图片上传*/
     Upload: Upload,
    //  Categoryas,
     draggable,
     Uediter
  },
  data() {
    return {
         /*是否上传图片*/
         isupload: false,
      isImg: false,  
         /*富文本配置*/
         ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        category_id:0,
        context:"",
        media:[],
        publish_time:"",
        associated_authors:"",
        mentioned_friends:"",
        tags:[],
        review_status:"",
        status:0,
        type:0,
        last_updated:"",
        views:0,
        fview:0,
        likes:0,
        flikes:0,
        shares:0,
        fshares:0,
        is_featured:0,
        is_pinned:0,
      },
      loading: false,
      /*验证规则*/
      rules: {
       
      },
      dialogVisible:false,
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
      code:"album",
              catgory: [],
    };
  },
  created() {
    console.log(11111)
    this.getCategory();
    this.dialogVisible = this.open_add;
  },
  props: ["open_add"],
  methods: {
    getCategory(){
        let self = this;
        NotesApi.catList({
          
        }, true)
          .then(data => {
            self.loading = false;
            self.catgory = data.data.list;

          })
          .catch(error => {
            self.loading = false;
          });
    },
    chooseCategory(){
      this.iscategorya = true;
    },
     /*上传*/
     openUpload(e) {
      this.isupload = true;
    },


     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },

    onSubmit() {
      let self = this;
      let form = self.form;

      form.context = this.$refs.ue.getUEContent();
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          NotesApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
     /*打开上传图片*/
     openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

    /*上传商品图片*/
    /*上传商品图片和视频*/
  returnProductImgsFunc(e) {
    if(this.code == 'album'){
      if (e != null) {
        // 支持的图片格式
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        // 支持的视频格式
        let videoExpt = ["mp4", "avi", "mov", "wmv", "flv", "mkv", "webm"];
        // 合并所有支持格式
        let allExpt = [...imgExpt, ...videoExpt];
        
        let prevent = false;
        
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1].toLowerCase();
          
          allExpt.forEach((exp) => {
            if (exp === ext) {
              prevent = true;
              return false;
            }
          });
        });

        if (!prevent) {
          this.$message.error("文件类型有误,请选择正确的图片或视频格式");
          return false;
        }

        let imgs = this.form.media.concat(e);
        this.$set(this.form, "media", imgs);
      }
    } else {
      if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true;
              return false;
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.media.concat(e);
        this.$set(this.form, "media", imgs);
      }
    }
    
    this.isProductUpload = false;
  },

  // 新增方法：判断是否为视频文件
  isVideoFile(filePath) {
    if (!filePath) return false;
    
    const videoExtensions = ["mp4", "avi", "mov", "wmv", "flv", "mkv", "webm"];
    const extension = filePath.split('.').pop().toLowerCase();
    
    return videoExtensions.includes(extension);
  },

    /*删除商品图片*/

    deleteImg(index,code) {
      this.form.media.splice(index, 1);

    },

  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}


.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/notes/index/part/add.vue